var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSvgrepoCom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0189 6.08443C12.4223 3.52815 13.1239 2.25 14.173 2.25C15.2221 2.25 15.9238 3.52814 17.3271 6.08442L17.6901 6.74576C18.089 7.47217 18.2883 7.83539 18.5993 8.07504C18.9102 8.31468 19.2973 8.40364 20.0717 8.58156L20.7768 8.74353C23.5019 9.36963 24.8645 9.68267 25.1887 10.7412C25.5129 11.7997 24.584 12.9027 22.7261 15.1086L22.2455 15.6794C21.7176 16.3062 21.4535 16.6196 21.3348 17.0074C21.2161 17.3952 21.256 17.8134 21.3358 18.6498L21.4085 19.4112C21.6893 22.3544 21.8298 23.826 20.9811 24.4802C20.1323 25.1344 18.8566 24.5379 16.305 23.3451L15.6449 23.0364C14.9199 22.6974 14.5574 22.5279 14.173 22.5279C13.7887 22.5279 13.4262 22.6974 12.7011 23.0364L12.041 23.3451C9.48946 24.5379 8.21368 25.1344 7.36498 24.4802C6.51627 23.826 6.65671 22.3544 6.93759 19.4112L7.01025 18.6498C7.09008 17.8134 7.12999 17.3952 7.01123 17.0074C6.89248 16.6196 6.62852 16.3062 6.10058 15.6794L5.61994 15.1086C3.76211 12.9027 2.83319 11.7997 3.15737 10.7412C3.48155 9.68267 4.84412 9.36963 7.56927 8.74353L8.2743 8.58156C9.04869 8.40364 9.43589 8.31468 9.74679 8.07504C10.0577 7.83539 10.2571 7.47218 10.6559 6.74576L11.0189 6.08443Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSvgrepoCom);
export default __webpack_public_path__ + "static/media/star-svgrepo-com.2b4a9f77c50d275aae790a0801719167.svg";
export { ForwardRef as ReactComponent };